import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface Props {
  title: string;
  value: string | number;
  change?: number;
  changeType?: 'increase' | 'decrease' | 'neutral';
  icon: React.ReactNode;
  description?: string;
  loading?: boolean;
}

export default function KPICard({ 
  title, 
  value, 
  change, 
  changeType = 'neutral', 
  icon, 
  description,
  loading = false 
}: Props) {
  const getTrendIcon = () => {
    switch (changeType) {
      case 'increase':
        return <TrendingUp className="w-4 h-4 text-pastel-green-600" />;
      case 'decrease':
        return <TrendingDown className="w-4 h-4 text-red-500" />;
      default:
        return <Minus className="w-4 h-4 text-gray-400" />;
    }
  };

  const getTrendColor = () => {
    switch (changeType) {
      case 'increase':
        return 'text-pastel-green-600';
      case 'decrease':
        return 'text-red-500';
      default:
        return 'text-gray-400';
    }
  };

  if (loading) {
    return (
      <div className="card-pastel p-6 animate-pulse">
        <div className="flex items-center justify-between mb-4">
          <div className="w-8 h-8 bg-white/60 rounded"></div>
          <div className="w-16 h-4 bg-white/60 rounded"></div>
        </div>
        <div className="w-24 h-8 bg-white/60 rounded mb-2"></div>
        <div className="w-32 h-4 bg-white/60 rounded"></div>
      </div>
    );
  }

  return (
    <div className="card-pastel p-6 hover:bg-white/90 transition-colors">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2 text-gray-500">
          {icon}
          <span className="text-sm font-medium">{title}</span>
        </div>
        {change !== undefined && (
          <div className="flex items-center space-x-1">
            {getTrendIcon()}
            <span className={`text-sm font-medium ${getTrendColor()}`}>
              {Math.abs(change).toFixed(1)}%
            </span>
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        <p className="text-2xl font-bold text-gray-800 font-poppins">{value}</p>
        {description && (
          <p className="text-sm text-gray-500">{description}</p>
        )}
      </div>
    </div>
  );
}
